// 執行階段設定組裝 — 由常數 + 產生的連線建立。
// 後續以 Unity 匯出的 reel-setting / paytable JSON 取代部分內容。
import { REEL_COUNT, ROW_COUNT, SYMBOL_NAMES } from '../constants'
import { defaultPaylines } from './paylines'

export interface RuntimeConfig {
  readonly reelCount: number
  readonly rowCount: number
  readonly symbolNames: readonly string[]
  readonly paylines: readonly (readonly number[])[]
}

export function createRuntimeConfig(): RuntimeConfig {
  return {
    reelCount: REEL_COUNT,
    rowCount: ROW_COUNT,
    symbolNames: SYMBOL_NAMES,
    // 兌獎連線：Unity 權威 5 線（3 排 + 2 對角，見 paylines.ts）
    paylines: defaultPaylines(),
  }
}
